module.exports = __webpack_public_path__ + "media/images/plans/schedule_3-b4bbad404feaf966c95aaded1f4420bd.jpg";